import type { ReactNode } from 'react';

/**
 * Shared page header: a large title with a muted one-line subtitle on the left and the
 * page's actions on the right. Use one primary button per page; make the rest outline or
 * ghost. `badge` sits beside the title (e.g. the mock-mode badge).
 */
export function PageHeader({
  title,
  description,
  badge,
  actions,
}: {
  title: ReactNode;
  description?: ReactNode;
  badge?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header className="flex flex-wrap items-end justify-between gap-x-6 gap-y-3">
      <div className="min-w-0">
        <div className="flex items-center gap-3 flex-wrap">
          <h1 className="m-0 text-[28px] leading-[1.15] font-semibold tracking-[-0.02em] text-balance">
            {title}
          </h1>
          {badge}
        </div>
        {description ? (
          <p className="m-0 mt-1 text-sm text-muted max-w-[70ch] text-pretty">{description}</p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex flex-wrap items-center gap-2 max-sm:w-full">{actions}</div>
      ) : null}
    </header>
  );
}
